import * as React from 'react';
import classNames from 'classnames';
// eslint-disable-next-line import/no-cycle
import { getWeatherIcon } from '../../utils/util';

type Props = {
  code: number
};

const WeatherIcon = (props: Props) => {
  const { code } = props;
  const icon = getWeatherIcon(code);
  const iconClasses = classNames({
    wi: true,
    'weather-icon': true,
    [icon]: true
  });

  return <i className={iconClasses} />;
};

export default WeatherIcon;
